import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import BlogList from "../../components/BlogList/BlogList.js";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const BlogPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <PageTitle pageTitle={"Latest News"} pagesub={"Blog"} />
      <BlogList />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default BlogPage;
